/* eslint-disable @typescript-eslint/no-explicit-any */
import IconOpen from '@/sinister/header/components/common/IconOpen'
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import styled from 'styled-components'
import Text from './Text'

const StyledMainButton = styled.button`
  grid-area: moreAbout;
  cursor: pointer;
  background-color: transparent;
  border: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
`

const MainButtonLogic = ({
  Wrapper,
  onClick,
}: {
  Wrapper: any
  onClick: () => void
}) => {
  const {
    colorSubheader: color,
    copies: { header: copy },
  } = useHeaderContext()
  const { moreDetails } = copy || {}

  return (
    <Wrapper onClick={onClick}>
      <Text text={moreDetails} color={color} />
      <IconOpen />
    </Wrapper>
  )
}

const MainButton = ({ onClick }: { onClick: () => void }) => (
  <MainButtonLogic Wrapper={StyledMainButton} onClick={onClick} />
)

export default MainButton
